import { HttpErrorResponse } from '@angular/common/http';

/** True when an HTTP failure is a transient network blip (browser offline or request
 *  aborted, e.g. during standby/idle) rather than a real server-side error. */
export function isTransientNetworkError(error: unknown): boolean {
    if (error instanceof HttpErrorResponse && error.status === 0) {
        return true;
    }
    return typeof navigator !== 'undefined' && navigator.onLine === false;
}
